module.exports = __webpack_public_path__ + "img/pricing_night.c0cb25d2.svg";